<script>
import api from '@utils/api'

export default {
  name: 'GoodsNew',
  props: {
    newItem: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: false,
      valid: true,
      item: {
        shortName: null,
        fullName: null,
        status: 1,
        description: null,
        employer: null,
        group: null,
        articleNumber: null,
      },
      rules: {
        shortName: [x => !!x || this.$t('validation__is_required')],
        fullName: [x => !!x || this.$t('validation__is_required')],
        status: [x => !!x || this.$t('validation__is_required')],
        group: [x => !!x || this.$t('validation__is_required')],
        articleNumber: [x => !!x || this.$t('validation__is_required')],
      },
    }
  },
  computed: {
    isArticleRequired() {
      return this.item.group === 6
    },
    status() {
      return this.$store.getters['data/getDictionary']('goodsstatus')
    },
    employer() {
      return this.$store.getters['data/getOrganization']
    },
    group() {
      const groups = this.$store.getters['data/getDictionary']('goodsgroup')
      if (!groups) return []
      return groups.filter(item => item.code !== 5)
      .map(item => {
        item.translatedGroup = this.$t(`goodsgroup.${item.code}.name`)
        return item
      })
    },
  },
  created() {
    Object.assign(this.item, this.goods) // Клонируем пропсы в стейт
  },
  methods: {
    closeItem() {
      this.$refs.newForm.reset()
      this.item.status = 1
      this.$emit('close-modal')
    },
    createGoods() {
      if (this.$refs.newForm.validate()) {
        this.loading = true
        api
          .createGoods(this.item)
          .then(async response => {
            this.$store.dispatch('data/updateDictionary', 'goods')
            if (this.item.group === 1)
              await this.createDefaultDensity(response.id)
            this.$router.push(`goods/${response.id}`)
          })
          .catch(() => {})
          .then(() => {
            this.loading = false
          })
      }
    },
    async createDefaultDensity(id) {
      try {
        await api.createSubItem('goods', id, 'oilcharacts', {
          density15c: 960,
        })
      } catch (error) {
        //
      }
    },
  },
}
</script>

<template>
  <v-dialog
    v-model="newItem"
    persistent
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        <v-spacer />
        <div class="headline">{{ $t('titles__add_new_goods') }}</div>
        <v-spacer />
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex
              xs12
              class="text-xs-center"
            >
              <v-form
                ref="newForm"
                v-model="valid"
                lazy-validation
              >
                <v-text-field
                  :label="$t('label__full_name')"
                  v-model="item.fullName"
                  :rules="rules.fullName"
                  name="completeName"
                  autocomplete="off"
                  required
                />
                <v-text-field
                  :label="$t('label__short_name')"
                  v-model="item.shortName"
                  :rules="rules.shortName"
                  name="shortName"
                  autocomplete="off"
                  required
                />
                <v-text-field
                  :label="$t('label__description')"
                  v-model="item.description"
                  name="description"
                  autocomplete="off"
                />
                <v-select
                  :items="employer"
                  :label="$t('label__employer')"
                  v-model="item.employer"
                  :no-data-text="$t('label__no_data_available')"
                  item-text="shortName"
                  item-value="id"
                  autocomplete
                />
                <v-select
                  :items="group"
                  :label="$t('label__group')"
                  v-model="item.group"
                  :rules="rules.group"
                  item-text="translatedGroup"
                  item-value="code"
                  autocomplete
                  required
                />
                <v-text-field
                  :label="$t('label__article_number')"
                  v-model="item.articleNumber"
                  :required="isArticleRequired"
                  :rules="isArticleRequired ? rules.articleNumber : []"
                  name="articleNumber"
                  autocomplete="off"
                />
              </v-form>
            </v-flex>
            <small>* {{ $t('label__requier_small_text') }}</small>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          :disabled="loading"
          color="secondary"
          @click="closeItem">{{ $t('buttons__close') }}</v-btn>
        <v-btn
          :disabled="loading"
          :loading="loading"
          color="primary"
          @click="createGoods">{{ $t('buttons__create') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" module>
@import '@design';
.btnWrapper {
  margin-top: 26px;
  margin-left: -8px;
}
</style>
